import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../app-core/services/common.service';
import { NavigationStateService } from '../../app-core/services/navigation-state.service';

@Component({
    selector: 'app-booking-redirect',
    template: `<p>Redirecting...</p>`
})
export class BookingRedirectComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService,
        private navigationStateService: NavigationStateService
    ) { }

    ngOnInit(): void {
        const orderNumber = this.route.snapshot.paramMap.get('orderNumber');

        this.commonService.getUpiByOrderNumber(orderNumber).subscribe({
            next: (response) => {
                const upi = response?.arrowxl_getupi_response?.status?.UPI;
                this.router.navigate(
                    ['/tracking'],
                    {
                        queryParams: { upi }
                    }
                );
            },
            error: (error) => {
                const message =
                    error?.error?.arrowxl_getupi_response?.status?.message || 'Something went wrong';

                this.navigationStateService.setErrorMessage(message);

                this.router.navigate(['']);

            }
        });
    }
}
